import {ActionContext} from "vuex";
import {IAppState} from "@/interfaces/app-state.interface";
import {Vue} from "vue-property-decorator";
import {IAppTable} from "@/shared/AppTable/interfaces/sort-table-data";
import {ICorpsStore} from "@/modules/Corps/interfaces/corps-store.interface";
import {corpRequest} from "@/modules/Corps/resources/corp.resource";
import {IApp} from "@/interfaces/app.interface";
import {ICorp} from "@/modules/Corps/interfaces/corp.interface";

type CorpsStoreType = ActionContext<ICorpsStore.IState, IAppState>;

export const CorpsStore: ICorpsStore.ICorpStoreModule = {
  namespaced: true,

  state: {
    table: [],
    filters: null,

    tableName: 'corps',
    sortingTable: {
      prop: null,
      propType: IApp.SortingPropType.String,
      direction: IApp.SortDirection.Default,
    },

    loading: false,
  },
  mutations: {
    setProperty(state: ICorpsStore.IState, { name, value }: { name: string, value: any}) { Vue.set(state, name, value); },
    setSubProperty(state: ICorpsStore.IState, { block, name, value }: { block: string, name: string, value: any}) { Vue.set(state[block], name, value); },
    startLoading(state: ICorpsStore.IState) { state.loading = true },
    stopLoading(state: ICorpsStore.IState) { state.loading = false },
    setSorting(state: ICorpsStore.IState, cell: IAppTable.ITableProp) {
      let sortingData = IAppTable.SetSorting(state.sortingTable, cell, state.tableName);
      Vue.set(state, 'sortingTable', sortingData);
    },

    addNewTableItem(state: ICorpsStore.IState, { corp }: { corp: ICorp.IEntity }) {
      state.table.unshift(corp);
    },
    updateTableItem(state: ICorpsStore.IState, { corp }: { corp: ICorp.IEntity }) {
      let tableCorpIndex = state.table.findIndex(item => item.id === corp.id);
      if (tableCorpIndex !== -1) {
        Vue.set(state.table, tableCorpIndex, corp);
      }
    }
  },
  getters: {
    sortedList: (state: ICorpsStore.IState) => {
      return IAppTable.SortTableData({
        tableData: state.table,
        sortingTable: state.sortingTable,
        limitTotal: 10000,
      });
    },
  },
  actions: {
    async init(store: CorpsStoreType) {
      store.commit('setProperty', {
        name: 'filters',
        value: {
          ...ICorpsStore.DefaultFilters,
          fltOwnerCorpId: store.rootState.auth.userAccess.fltOwnerCorpId,
        }
      });
      let presetSorting = IAppTable.PresetStorageSorting(store.state.tableName);
      if (presetSorting) store.commit('setProperty', { name: 'sortingTable', value: presetSorting });
      await store.dispatch('getTable');
    },

    async getTable(store: CorpsStoreType) {
      store.commit('startLoading');
      let asyncAction = async () => {
        let tableData = await corpRequest.getCorpsList({ filters: store.state.filters });
        store.commit('setProperty', { name: 'table', value: tableData });
      };

      await store.dispatch('defaultResourceAction', { asyncAction }, { root: true });
      store.commit('stopLoading');
    },


    async clearFilters(store: CorpsStoreType) {
      store.commit('setProperty', {
        name: 'filters',
        value: {
          ...ICorpsStore.DefaultFilters,
          fltOwnerCorpId: store.rootState.auth.userAccess.fltOwnerCorpId,
        }
      });
      await store.dispatch('getTable');
    },
  }
};
